// extracted by mini-css-extract-plugin
module.exports = {"postMeta":"post-module--post-meta--1ci95","pagination":"post-module--pagination--1F-V0"};